/**
 * Convertit une chaîne base64 en Blob
 * @param {string} base64 - Chaîne base64 (sans le préfixe data:...)
 * @param {string} mimeType - Type MIME du fichier (ex: 'application/pdf')
 * @returns {Blob} Blob créé à partir du base64
 */
export const base64ToBlob = (base64, mimeType = 'application/pdf') => {
  const binaryString = window.atob(base64)
  const binaryLen = binaryString.length

  const bytes = new Uint8Array(binaryLen)
  for (let i = 0; i < binaryLen; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  return new Blob([bytes], { type: mimeType })
}

/**
 * Déclenche le téléchargement d'un Blob
 * @param {Blob} blob - Le blob à télécharger
 * @param {string} filename - Nom du fichier à télécharger
 */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()

  // Nettoyer
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

/**
 * Télécharge directement un fichier depuis une chaîne base64
 * @param {string} base64 - Chaîne base64
 * @param {string} filename - Nom du fichier
 * @param {string} mimeType - Type MIME du fichier
 */
export const downloadBase64File = (
  base64,
  filename,
  mimeType = 'application/pdf'
) => {
  const blob = base64ToBlob(base64, mimeType)
  downloadBlob(blob, filename)
}
